export default __webpack_public_path__ + "static/media/cb_4.ec660dcb.png";